@if (notification().visible) {
<app-notification
  [type]="notification().type"
  [title]="notification().title"
  [message]="notification().message"
  style="position: fixed; top: 20px; right: 20px; z-index: 99999"
/>
}

<router-outlet />
